module.exports = __webpack_public_path__ + "img/advantage_4.cc98c524.png";